var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0202 0.720973C11.1623 1.17033 10.9714 1.65791 10.5619 1.89128C8.44567 3.09749 7.02246 5.372 7.02246 7.97766C7.02246 11.8437 10.1565 14.9777 14.0225 14.9777C16.6279 14.9777 18.9023 13.5547 20.1086 11.4387C20.342 11.0293 20.8296 10.8384 21.2789 10.9805C21.7282 11.1227 22.0174 11.5592 21.9728 12.0284C21.4431 17.611 16.7433 21.9774 11.0225 21.9774C4.94733 21.9774 0.0224609 17.0526 0.0224609 10.9774C0.0224609 5.25631 4.3893 0.556323 9.97234 0.0269625C10.4415 -0.0175236 10.8781 0.271619 11.0202 0.720973ZM6.33756 3.29122C3.74989 4.87201 2.02246 7.72327 2.02246 10.9774C2.02246 15.948 6.0519 19.9774 11.0225 19.9774C14.2764 19.9774 17.1274 18.2503 18.7083 15.6629C17.3437 16.4968 15.7394 16.9777 14.0225 16.9777C9.0519 16.9777 5.02246 12.9482 5.02246 7.97766C5.02246 6.26046 5.50351 4.65594 6.33756 3.29122Z",
    fill: "#89B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moonIcon.899b6e2c11396e13aba67d97a443f020.svg";
export { ForwardRef as ReactComponent };